// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"8a43c0d1","880":"20525aac"}[chunkId] + ".chunk.css";
};